// FILE: client/src/pages/Terms.js

export default function Terms() {
  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: "0 16px", color: "white" }}>
      <h1>Terms of Service</h1>
      <p>Effective Date: January 2026</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to WatchParty Rooms (“we,” “our,” “us”). By using watchpartyrooms.com or any related services,
        you agree to these Terms of Service.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        WatchParty Rooms provides a tool that allows users to create private rooms and share third-party video links.
        <strong> We do not host, stream, or store any video content.</strong>
      </p>

      <h2>3. User Responsibilities</h2>
      <p>
        You agree not to use WatchParty Rooms to share illegal content, infringe copyrights, harass others, or disrupt the service.
        You are solely responsible for the links and content you share.
      </p>

      <h2>4. Service Availability</h2>
      <p>
        We do not guarantee uninterrupted service and may modify or discontinue features at any time.
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        The service is provided “as-is.” We are not liable for damages arising from your use of the service.
      </p>

      <h2>6. Contact</h2>
      <p>Email: watchpartyrooms@gmail.com</p>
    </div>
  );
}
